import { render, staticRenderFns } from "./EHS.vue?vue&type=template&id=e3815592&scoped=true"
import script from "./EHS.vue?vue&type=script&lang=js"
export * from "./EHS.vue?vue&type=script&lang=js"
import style0 from "./EHS.vue?vue&type=style&index=0&id=e3815592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3815592",
  null
  
)

export default component.exports